<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" :disable-backdrop-click="loading">
    <div class="mx-auto w-full max-w-xl">
      <BaseCard>
        <BaseCardHeader> Phone Numbers </BaseCardHeader>
        <BaseCardBody>
          <div class="divide-y divide-gray-200 -my-4">
            <PhoneNumberLine
              v-for="phoneNumber in phoneNumbers"
              :key="phoneNumber.id"
              :contact-id="contactId"
              :phone-number="phoneNumber"
              :primary="primaryPhoneNumber && phoneNumber.id === primaryPhoneNumber.id"
              :on-change="onRefreshContact"
            />
            <NewPhoneNumberLine :contact-id="contactId" :on-created="onRefreshContact" />
          </div>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import PhoneNumberLine from './PhoneNumberLine.vue';
import NewPhoneNumberLine from './NewPhoneNumberLine.vue';

export default {
  components: {
    PhoneNumberLine,
    NewPhoneNumberLine,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
    primaryPhoneNumber: {
      type: Object,
      default: () => null,
    },
    phoneNumbers: {
      type: Array,
      default: () => [],
    },
    onRefreshContact: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    //
  },
};
</script>
